import type { RouteObject } from 'react-router';
import { RolePage } from './RolePage';
import { StaffMemberPage } from './StaffMemberPage';

/** Detail routes (paths without a leading slash). */
export const ADMIN_ROUTES: RouteObject[] = [
  { path: 'admin/staff/:id', element: <StaffMemberPage /> },
  { path: 'admin/roles/:code', element: <RolePage /> },
];
